// extracted by mini-css-extract-plugin
export default {"table":"Table__table___35sm7"};